// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "ABSENCE_REASON_ALERT_TYPE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      absenceReasonAlertType: {
        required: findSchemaRequired(typeSchema, "absenceReasonAlertType"),
        title: "Absence Reason Alert Type",
        properties: {
          absenceReasons: findSchemaPropertyByName(
            typeSchema,
            "absenceReasonAlertType",
            "absenceReasons",
          ),
        },
        type: "object",
      },
    },
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  absenceReasonAlertType: {
    absenceReasons: {
      "ui:widget": "hidden",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
